import React from 'react';
import { getPathToTypeList } from '../../utils/listBodyUtils';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

import './LinksAndCurrentLocation.css';
import { getTranslation } from '../../assets/creator/translations';
import ElementsMissingWarningIcon from '../ElementsMissingWarningIcon/ElementsMissingWarningIcon';

const getRoutes = () => (getPathToTypeList().map(route => (
    {
        title: getTranslation(route.pageTranslationKey),
        to: route.path,
        index: route.index,
        listName: route.listName
    }
)))

const GetShowMenuHandler = (props, linkList) => (
    () => {
        if (!props.isDragStarted()) {
            linkList.current.style.display = 'block';
        }
    }
)

const GetHideMenuHandler = (linkList) => (
    () => {
        linkList.current.style.display = 'none';
    }
)

const GetLinks = () => {
    const allLinks = getRoutes();
    const location = allLinks.find((link) => { 
        if (link.to === window.location.pathname) {
            return link;
        }
        return null; 
    });
    let activeNavLink = 0;
    if (location) {
        activeNavLink = location.index;
    }

    const filteredLinks = allLinks.filter(({ index }) => activeNavLink !== index);

    return {
        allLinks: allLinks,
        activeNavLink: activeNavLink,
        filteredLinks: filteredLinks,

    };
}

const LinksToHtml = (filteredLinks, hideMenu, isMissingRequiredElement, isCheckEnabled) => (
    <React.Fragment>
        {
            filteredLinks.map((link) => (
                <li key={link.title}>
                    <NavLink onClick={hideMenu} exact="true" to={link.to} className="pages-dropdown__option">
                        <div className="pages-dropdown__link">{link.title}</div>
                        <div>
                            <ElementsMissingWarningIcon
                                show={isCheckEnabled && isMissingRequiredElement(link.listName)}
                            />
                        </div>
                    </NavLink>
                </li>
            ))
        }
    </React.Fragment>
)

const LinksAndCurrentLocation = (props) => {

    const { allLinks, activeNavLink, filteredLinks } = GetLinks();
    const linkList = React.createRef();
    //displays link list
    const showMenu = GetShowMenuHandler(props, linkList);
    //hides link list
    const hideMenu = GetHideMenuHandler(linkList);

    //maps lists to corresponding html elements and components
    const navLinks = LinksToHtml(filteredLinks, hideMenu, props.pageBodyMissingCheck, props.isCheckEnabled);

    return (
        <div
            className="pages-dropdown"
            onMouseEnter={showMenu}
            onMouseLeave={hideMenu}
        >

            <div className="pages-dropdown__current-page">
                <div className="pages-dropdown__current-page-title">
                    <span>{allLinks[activeNavLink].title}</span>
                </div>
                <FontAwesomeIcon icon={faCaretDown} />
            </div>
            <ul ref={linkList} className="pages-dropdown__linklist-wrapper">
                {navLinks}
            </ul>
        </div>
    );
}

export default LinksAndCurrentLocation;
export { GetLinks };
